import React, {useState} from 'react'
import styled from 'styled-components'
import {useInterval, formatDateAndTime} from '../../utils/time'

const DateTimeContainer = styled.div`
  color: white;
  box-sizing: border-box;
  @media (max-width: 420px) {
    grid-area: datetime;
  }
`

const Time = styled.div`
  font-size: ${props => (props.size === 'small' ? '32' : '60')}px;
  font-weight: normal;
  display: inline-block;

  @media (max-width: 420px) {
    font-size: 20px;
    font-weight: 600;
  }
`

const AmPm = styled.div`
  font-size: ${props => (props.size === 'small' ? '14px' : '24px')};
  display: inline-block;
  padding-left: 2px;
  padding-top: ${props => (props.size === 'small' ? '4px' : '16px')};
  vertical-align: top;

  @media (max-width: 420px) {
    font-size: 11px;
    padding-top: 4px;
  }
`

const DateContainer = styled.div`
  font-size: ${props => (props.size === 'small' ? '14' : '20')}px;
  padding-left: 0;
  width: 150px;
  color: ${props => (props.size === 'small' ? '#5f6886' : 'white')};
  white-space: nowrap;

  @media (max-width: 420px) {
    font-size: 11px;
    width: auto;
  }
`
const Clock = ({size}) => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useInterval(() => {
    setCurrentTime(new Date())
  }, 1000)

  const {time, ampm, date} = formatDateAndTime(currentTime)
  return (
    <DateTimeContainer>
      <Time size={size}>{time}</Time>
      <AmPm size={size}>{ampm}</AmPm>
      <DateContainer size={size}>{date}</DateContainer>
    </DateTimeContainer>
  )
}

export default Clock

Clock.defaultProps = {
  size: 'small'
}
